import update from 'immutability-helper';

import { Configuration } from '../../../interfaces/Configuration';
import Store from '../../../interfaces/Store';
import { ValidationAndLightingSetup } from '../../../interfaces/Validation';
import { validationAndLightingSetupReducer } from '../validate/validationAndLightingSetup.reducers';
import { addRequiredArticleNotificationIfNeeded } from './addRequiredArticleNotificationIfNeeded';

export const replaceConfigurationReducer = (
  store: Store,
  {
    configuration,
    validationAndLightingSetup,
    unsetSelectedArticleId,
    setNewSelectedArticleId,
  }: {
    configuration: Configuration;
    validationAndLightingSetup: ValidationAndLightingSetup;
    unsetSelectedArticleId?: string;
    setNewSelectedArticleId?: string;
  },
): Store => {
  if (unsetSelectedArticleId) {
    store = unsetSelectedArticle(unsetSelectedArticleId, store);
  }

  if (setNewSelectedArticleId) {
    store = setNewSelectedArticle(setNewSelectedArticleId, store);
  }

  const pastConfiguration = store.configuration;

  store = setConfiguration(store, configuration);
  store = validationAndLightingSetupReducer(store, validationAndLightingSetup);
  store = addRequiredArticleNotificationIfNeeded(pastConfiguration, store);

  return store;
};

function setConfiguration(store, configuration) {
  return update(store, {
    configuration: {
      $set: configuration,
    },
  });
}

function unsetSelectedArticle(articleId: string, store: Store) {
  const selectedArticle =
    store.selectedArticle?.id === articleId ? undefined : store.selectedArticle;
  return update(store, {
    selectedArticle: {
      $set: selectedArticle,
    },
  });
}

function setNewSelectedArticle(articleId: string, store: Store) {
  if (store.selectedArticle?.id === articleId) {
    return store;
  }
  return update(store, {
    selectedArticle: {
      $set: { ...store.selectedArticle, id: articleId },
    },
  });
}
